function engraveClose() {
	$('#additionalAttributesDrawer').removeClass('active');
	$('.engrave-submit-confirm').removeAttr('formid');
	$('body').removeClass('overflow-hidden');
	$('.custom--overlay').remove();
	if ($(window).innerWidth() <= 768) {
		$('.engrave--accordian').hide();
	}
}

$(document).on('click', '.engrave-close-btn', () => {
	engraveClose();
});
function engraveModalClose() {
	$('#myEngraveModal').hide();
}

function engraveInput() {
	let atLeastOneHasValue = false;
	$('.engrave--input input').each(function () {
		if ($(this).attr('type') == 'text') {
			if ($(this).val().trim() !== '') {
				$(this).closest('.accordian--group').addClass('has--content');
				// $(this).closest('.accordian--group').find('.engrave-confirm').prop('disabled', false);
			} else {
				$(this).closest('.accordian--group').removeClass('has--content');
				// $(this).closest('.accordian--group').find('.engrave-confirm').prop('disabled', true);
			}
			// } else if ($(this).attr('type') == 'radio') {
			//   if ($(this).is(':checked')) {
			//     $(this).closest('.accordian--group').addClass('has--content');
			//     // $(this).closest('.accordian--group').find('.engrave-confirm').prop('disabled', false);
			//   } else {
			//     $(this).closest('.accordian--group').removeClass('has--content');
			//     // $(this).closest('.accordian--group').find('.engrave-confirm').prop('disabled', true);
			//   }
		} else if ($(this).attr('type') == 'checkbox') {
			if ($(this).is(':checked')) {
				$(this).closest('.accordian--group').addClass('has--content');
				// $(this).closest('.accordian--group').find('.engrave-confirm').prop('disabled', false);
			} else {
				$(this).closest('.accordian--group').removeClass('has--content');
				// $(this).closest('.accordian--group').find('.engrave-confirm').prop('disabled', true);
			}
		}
	});
}
engraveInput();
$(document).on('input change', '.engrave--input input', () => {
	engraveInput();
});
$(document).on('click', '.accordian--content__container', function () {
	if ($(window).width() > 767) {
		if ($(this).closest('.accordian--group').find('.engrave--input').is(':visible')) {
			$('.engrave--input').hide();
		} else {
			$('.engrave--input').hide();
			$(this).closest('.accordian--group').find('.engrave--input').show();
		}
	}
});

const disableEmptyInputs = () => {
	//Engrave text
	const textInp = document.getElementById('engrave-name-input');
	const textConfirm = document.getElementById('engrave-text-confirm');
	textConfirm.disabled = textInp.value.length ? false : true;

	//Engrave style
	const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	let isStyleChecked = false;
	styleRadioButtons.forEach((button) => {
		if (button.checked) {
			isStyleChecked = true;
		}
	});
	const styleConfirm = document.getElementById('engrave-style-confirm');
	styleConfirm.disabled = isStyleChecked ? false : true;

	//Engrave color
	const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
	let isColorChecked = false;
	colorRadioButtons.forEach((button) => {
		if (button.checked) {
			isColorChecked = true;
		}
	});
	const colorConfirm = document.getElementById('engrave-color-confirm');
	colorConfirm.disabled = isColorChecked ? false : true;

	//Engrave Consent
	const engraveConsent = document.getElementById('engrave-consent-input');
	const consentConfirm = document.getElementById('engrave-consent-confirm');
	consentConfirm.disabled = !engraveConsent.checked;
};

const checkEmptyFields = () => {
	//Engrave text
	const textInp = document.getElementById('engrave-name-input');
	if (textInp.value.length) {
	} else {
		return { id: '#text-slick', index: 0 };
	}

	//Engrave style
	const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	let isStyleChecked = false;
	styleRadioButtons.forEach((button) => {
		if (button.checked) {
			isStyleChecked = true;
		}
	});
	if (!isStyleChecked) {
		return { id: '#style-slick', index: 1 };
	}

	//Engrave color
	const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
	let isColorChecked = false;
	colorRadioButtons.forEach((button) => {
		if (button.checked) {
			isColorChecked = true;
		}
	});
	if (!isColorChecked) {
		return { id: '#color-slick', index: 2 };
	}

	return null;
};
const addInputFormName = () => {
	const engraveContainer = document.querySelector(".engrave--accordian");
	const engraveInputs = engraveContainer.querySelectorAll("input");
	const productFormId = document.querySelector(".product-form form")?.getAttribute("id");
	engraveInputs.forEach(el => el.setAttribute("form", productFormId));
}
$(document).on('click', '.accordian--group button', function () {
	// check for empty fields
	const check = checkEmptyFields();
	if ($(window).width() > 767) {
		if ($(this).hasClass('engrave-submit-confirm')) {
			if (check == null) {
				addInputFormName();
				engraveClose();
				$('.engrave--input').hide(1000);
				$('.engrave--input:first').show(1000);
				$('#openDrawerButton').addClass('has--content');
				$('#openDrawerButton .engrave--btn--text').html('Modify my bottle');
			} else {
				$('.engrave--input').hide();
				$(check.id).show();
			}
		} else {
			$('.engrave--input').hide();
			$(this).closest('.accordian--group').next().find('.engrave--input').show();
		}
	} else {
		if ($(this).hasClass('engrave-submit-confirm')) {
			if (check == null) {
				$('.engrave--accordian').slick('slickGoTo', 0);
				engraveClose();
				$('#openDrawerButton').addClass('has--content');
				$('#openDrawerButton .engrave--btn--text').html('Modify my bottle');
				$('#openDrawerButton .engrave--btn--text').addClass('has--content');
				$('.engrave--accordian').slick('unslick');
			} else {
				$('.engrave--accordian').slick('slickGoTo', check.index);
			}
		} else {
			let currentSlide = $(this).closest('.accordian--group').attr('data-slick-index');
			let nextSlide = Number(currentSlide) + 1;
			$('.engrave--accordian').slick('slickGoTo', nextSlide);
		}
	}
});

$('.engrave--input:first').show();

$(document).on('click', '.engrave--clear', function () {
	$('#myEngraveModal').css('display', 'flex');
});
$(document).on('click', '#myEngraveModal #remove-gift-wrap', function () {
	$('.engrave--input input').each(function () {
		$(this).removeAttr("form");
		if ($(this).attr('type') === 'text') {
			$(this).val('');
		} else if ($(this).attr('type') === 'checkbox' || $(this).attr('name') === 'properties[_engravingColor]') {
			$(this).prop('checked', false);
		}
	});
	$("#engrave-dynamic").html("Your text here").removeAttr("style");
	$('#openDrawerButton .engrave--btn--text').html(' Engrave my bottle');
	$('#openDrawerButton').removeClass('has--content');
	engraveModalClose();
});
$(document).on('click', '#myEngraveModal .close', function () {
	engraveModalClose();
});

let openBtn = $('#openDrawerButton');
function detectClickOutsideDiv(divId, idTwo) {
	document.addEventListener('click', function (event) {
		const clickedElement = event.target;
		const targetDiv = document.getElementById(divId);
		if (
			clickedElement !== targetDiv &&
			!targetDiv.contains(clickedElement) &&
			$(event.target).closest(idTwo).length == 0
		) {
			// Click occurred outside the specified div
			$(`#${divId}`).removeClass('active');
			$('body').removeClass('overflow-hidden');
		}
	});
}

//for both
function openDrawer(dataPostion) {
	$('#additionalAttributesDrawer').addClass('active');
	dataValue = $('#openDrawerButton').data('formid');
	// $('.engrave-submit-confirm').attr('data-position', dataPostion);
	$('.engrave-submit-confirm').attr('formid', dataValue);
	$('body').addClass('overflow-hidden');
	$('body').append($('<div class="custom--overlay"></div>'));
	if ($(window).innerWidth() <= 768) {
		$('.engrave--accordian').show();
	}
}

$(document).on('click', '#openDrawerButton, .engrave-cart-wrap', function (e) {

	e.preventDefault();
	let dataPostion = $(this).attr('data-position');
	openDrawer(dataPostion);
	disableEmptyInputs();
	// detectClickOutsideDiv('additionalAttributesDrawer', '#openDrawerButton');
});

//web
$(document).on('click', '#webopenDrawerButton', function (e) {
	e.preventDefault();
	$('#webadditionalAttributesDrawer').addClass('active');
	detectClickOutsideDiv('webadditionalAttributesDrawer', '#webopenDrawerButton');
});

//mobile
$(document).on('click', '#mobileopenDrawerButton', function (e) {
	e.preventDefault();
	$('#mobileadditionalAttributesDrawer').addClass('active');
	detectClickOutsideDiv('mobileadditionalAttributesDrawer', '#mobileopenDrawerButton');
});
// engrave mobile slider
$(document).ready(function () {
	function mobileEngrave() {
		if ($(window).width() <= 767) {
			if (!$('.engrave--accordian').hasClass('slick-initialized')) {
				$('.engrave--accordian').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: false,
					arrows: true,
					infinite: false,
				});
			}
		}
	}
	// $(window).resize(function () {
	//   mobileEngrave();
	// });
	$(document).on('click', '#openDrawerButton, .engrave-cart-wrap', function () {
		mobileEngrave();
	});
});

document.addEventListener('DOMContentLoaded', () => {
	//Text input
	const textInp = document.getElementById('engrave-name-input');
	const textConfirm = document.getElementById('engrave-text-confirm');
	textInp?.addEventListener('input', (e) => {
		if (e.target.value.length) {
			textConfirm.removeAttribute('disabled');
		} else {
			textConfirm.setAttribute('disabled', 'true');
		}
	});

	//Engrave color
	const colorRadioButtons = document.querySelectorAll('[name="properties[_engravingColor]"]');
	const colorConfirmButton = document.getElementById('engrave-color-confirm');

	function checkColorRadioButtons() {
		let isChecked = false;
		colorRadioButtons.forEach((button) => {
			if (button.checked) {
				isChecked = true;
			}
		});
		colorConfirmButton.disabled = !isChecked;
		colorConfirmButton.closest('.accordian--group').classList.add('has--content');
	}

	colorRadioButtons.forEach((button) => {
		button.addEventListener('change', checkColorRadioButtons);
	});

	//Engrave style
	const styleRadioButtons = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	const styleConfirmButton = document.getElementById('engrave-style-confirm');

	function checkStyleRadioButtons() {
		let isChecked = false;
		styleRadioButtons.forEach((button) => {
			if (button.checked) {
				isChecked = true;
			}
		});
		if (styleConfirmButton) styleConfirmButton.disabled = !isChecked;
		styleConfirmButton?.closest('.accordian--group').classList.add('has--content');
	}

	styleRadioButtons.forEach((button) => {
		button.addEventListener('change', checkStyleRadioButtons);
	});

	//consent check
	const consentInp = document.getElementById('engrave-consent-input');
	const consentConfirm = document.getElementById('engrave-consent-confirm');
	consentInp?.addEventListener('input', (e) => {
		if (e.target.checked) {
			consentConfirm.removeAttribute('disabled');
		} else {
			consentConfirm.setAttribute('disabled', 'true');
		}
	});
});

const dynamicEngrave = () => {
	const textInp = document.getElementById('engrave-name-input');
	const engraveDynamic = document.getElementById('engrave-dynamic');
	textInp?.addEventListener('input', (e) => {
		engraveDynamic.innerText = e.target.value;
	});

	const styleRadios = document.querySelectorAll('[name="properties[_engravingStyle]"]');
	styleRadios.forEach((radio) => {
		radio.addEventListener('change', function () {
			if (this.checked) {
				const font = this.getAttribute('data-font');
				engraveDynamic.style.fontFamily = font;
			}
		});
	});

	const colorRadios = document.querySelectorAll('[name="properties[_engravingColor]"]');
	colorRadios.forEach((radio) => {
		radio.addEventListener('change', function () {
			if (this.checked) {
				const color = this.getAttribute('data-color');
				engraveDynamic.style.color = color;
			}
		});
	});
};

document.addEventListener('DOMContentLoaded', () => {
	dynamicEngrave();
});

const textConfirmButton = document.getElementById("engrave-text-confirm");
textConfirmButton.addEventListener("click",()=>{
	const errMsgAvl = document.getElementById("engrave--err-text--input");
	errMsgAvl? errMsgAvl.remove() : null;
})

